export const INITIAL = 0;
export const DISPATCHING = 1;
export const SUCCESS = 2;
export const ERROR = 3;
